(function() {
  'use strict';

  // Guard against double-loading (e.g. included both globally in theme.liquid
  // and by a product/cart section). Only the first copy runs.
  if (window.__hwEmbedActive) return;
  window.__hwEmbedActive = true;

  var EDITOR_BASE = 'https://hw-gifts.web.app/editor';
  var CSS_PREFIX = 'hw-editor-';
  var editorLoaded = false;
  var editorLoading = false;
  var currentVariantId = null;
  var customizerId = null;
  var currentEditorInstance = null;
  // Button references so we can show/hide per variant.
  var hwButton = null;
  var nativeAtcButton = null;
  var nativePaymentButton = null;

  function getConfig() {
    if (window.__customizerConfig) {
      return window.__customizerConfig;
    }

    var meta = document.querySelector('meta[name="hw-customizer-id"]');
    if (meta && meta.content) {
      return { id: meta.content, productId: meta.dataset.productId || null };
    }

    var formEl = document.querySelector('[data-customizer-id]');
    if (formEl) {
      return { id: formEl.dataset.customizerId };
    }

    return null;
  }

  function getCustomizerIdForVariant(variantId) {
    var config = window.__customizerConfig;
    if (config && config.variants && config.variants.length) {
      for (var i = 0; i < config.variants.length; i++) {
        if (String(config.variants[i].id) === String(variantId)) {
          // Variant value already resolves variant -> parent in Liquid.
          // Returns null when neither the variant nor parent has a config,
          // so this variant is treated as non-customizable.
          return config.variants[i].customizerId || null;
        }
      }
    }
    return (config && config.id) || customizerId;
  }

  function getLayoutIdForVariant(variantId) {
    var config = window.__customizerConfig;
    if (config && config.variants && config.variants.length) {
      for (var i = 0; i < config.variants.length; i++) {
        if (String(config.variants[i].id) === String(variantId)) {
          return config.variants[i].layoutId || null;
        }
      }
    }
    return (config && config.layoutId) || null;
  }

  function getOverlayIdForVariant(variantId) {
    var config = window.__customizerConfig;
    if (config && config.variants) {
      for (var i = 0; i < config.variants.length; i++) {
        if (String(config.variants[i].id) === String(variantId)) {
          return config.variants[i].overlayId || config.overlayId || null;
        }
      }
    }
    return (config && config.overlayId) || null;
  }

  // A variant is customizable only when it resolves to BOTH a customizer id
  // and a layout id (variant metafield, else parent product metafield).
  function variantHasCustomizer(variantId) {
    var cid = getCustomizerIdForVariant(variantId);
    var lid = getLayoutIdForVariant(variantId);
    return !!(cid && String(cid).trim() && lid && String(lid).trim());
  }

  // Toggle between the HW "Customize This Product" button and the native
  // Add to Cart / payment buttons based on the current variant's config.
  function applyVariantState() {
    if (!hwButton) return;
    var canCustomize = variantHasCustomizer(currentVariantId);

    if (canCustomize) {
      hwButton.classList.remove(CSS_PREFIX + 'hidden');
      if (nativeAtcButton) nativeAtcButton.classList.add(CSS_PREFIX + 'hidden');
      if (nativePaymentButton) nativePaymentButton.classList.add(CSS_PREFIX + 'hidden');
    } else {
      hwButton.classList.add(CSS_PREFIX + 'hidden');
      if (nativeAtcButton) nativeAtcButton.classList.remove(CSS_PREFIX + 'hidden');
      if (nativePaymentButton) nativePaymentButton.classList.remove(CSS_PREFIX + 'hidden');
    }
  }

  function getSelectedVariantId() {
    var urlParams = new URLSearchParams(window.location.search);
    var variantParam = urlParams.get('variant');
    if (variantParam) return variantParam;

    var variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"], ' +
      'form[action*="/cart/add"] select[name="id"]'
    );
    if (variantInput) return variantInput.value;

    var config = window.__customizerConfig;
    if (config && config.variants && config.variants.length > 0) {
      return String(config.variants[0].id);
    }

    return null;
  }

  function getProductTitle() {
    if (window.__customizerConfig && window.__customizerConfig.productTitle) {
      return window.__customizerConfig.productTitle;
    }
    var titleEl = document.querySelector('.product__title, .product-single__title, h1.title, [data-product-title]');
    return titleEl ? titleEl.textContent.trim() : document.title;
  }

  function findAddToCartButton() {
    var selectors = [
      'form[action*="/cart/add"] [type="submit"]',
      'form[action*="/cart/add"] button[name="add"]',
      'form[action*="/cart/add"] .btn--add-to-cart',
      'form[action*="/cart/add"] .product-form__submit',
      'form[action*="/cart/add"] .shopify-payment-button',
      '.product-form button[type="submit"]',
      '#AddToCart',
      '#add-to-cart',
      '.add-to-cart'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function injectStyles() {
    if (document.getElementById(CSS_PREFIX + 'styles')) return;

    var style = document.createElement('style');
    style.id = CSS_PREFIX + 'styles';
    style.textContent = [
      '.' + CSS_PREFIX + 'btn {',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  gap: 8px;',
      '  width: 100%;',
      '  height: 48px;',
      '  padding: 0 24px;',
      '  border: none;',
      '  border-radius: 8px;',
      '  background: linear-gradient(135deg, #6366f1, #8b5cf6);',
      '  color: #fff;',
      '  font-size: 16px;',
      '  font-weight: 600;',
      '  font-family: inherit;',
      '  cursor: pointer;',
      '  transition: opacity 0.2s, transform 0.1s;',
      '  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);',
      '  margin-bottom: 12px;',
      '}',
      '.' + CSS_PREFIX + 'btn:hover {',
      '  opacity: 0.9;',
      '  transform: translateY(-1px);',
      '}',
      '.' + CSS_PREFIX + 'btn:active {',
      '  transform: translateY(0);',
      '}',
      '.' + CSS_PREFIX + 'btn svg {',
      '  width: 20px;',
      '  height: 20px;',
      '  fill: currentColor;',
      '}',
      '.' + CSS_PREFIX + 'toast {',
      '  position: fixed;',
      '  bottom: 24px;',
      '  right: 24px;',
      '  background: #10b981;',
      '  color: #fff;',
      '  padding: 14px 24px;',
      '  border-radius: 8px;',
      '  font-size: 14px;',
      '  font-weight: 500;',
      '  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;',
      '  box-shadow: 0 4px 12px rgba(0,0,0,0.15);',
      '  z-index: 999999;',
      '  opacity: 0;',
      '  transform: translateY(12px);',
      '  transition: opacity 0.3s, transform 0.3s;',
      '}',
      '.' + CSS_PREFIX + 'toast--visible {',
      '  opacity: 1;',
      '  transform: translateY(0);',
      '}',
      '.' + CSS_PREFIX + 'hidden { display: none !important; }',
      '.hw-cart-edit-btn {',
      '  display: inline-flex;',
      '  align-items: center;',
      '  gap: 5px;',
      '  font-size: 12px;',
      '  font-weight: 500;',
      '  color: #2563eb;',
      '  text-decoration: none;',
      '  padding: 4px 10px;',
      '  border: 1px solid #2563eb;',
      '  border-radius: 5px;',
      '  margin-top: 6px;',
      '  transition: background 0.15s, color 0.15s;',
      '}',
      '.hw-cart-edit-btn:hover {',
      '  background: #2563eb;',
      '  color: #fff;',
      '}',
      '.hw-cart-edit-btn:hover svg { stroke: #fff; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function createButton() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = CSS_PREFIX + 'btn';
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67A2.5 2.5 0 0 1 12 22zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5a.54.54 0 0 0-.14-.35c-.41-.46-.63-1.05-.63-1.65a2.5 2.5 0 0 1 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"/>' +
      '<circle cx="6.5" cy="11.5" r="1.5"/>' +
      '<circle cx="9.5" cy="7.5" r="1.5"/>' +
      '<circle cx="14.5" cy="7.5" r="1.5"/>' +
      '<circle cx="17.5" cy="11.5" r="1.5"/>' +
      '</svg>' +
      '<span>Customize This Product</span>';
    return btn;
  }

  function showToast(message) {
    var existing = document.querySelector('.' + CSS_PREFIX + 'toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = CSS_PREFIX + 'toast';
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add(CSS_PREFIX + 'toast--visible');
    });

    setTimeout(function() {
      toast.classList.remove(CSS_PREFIX + 'toast--visible');
      setTimeout(function() { toast.remove(); }, 300);
    }, 3000);
  }

  function updateCartCount(count) {
    var selectors = [
      '.cart-count',
      '.cart-count-bubble span',
      '#CartCount',
      '.site-header__cart-count',
      '[data-cart-count]',
      '.js-cart-count',
      '.header__cart-count'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        el.textContent = count;
        el.setAttribute('data-cart-count', count);
      }
    }
  }

  function addToCart(data) {
    var variantId = data.variantId || currentVariantId;
    if (!variantId) {
      showToast('No product variant selected.');
      console.error('[HW Customizer] Missing variantId');
      return Promise.reject(new Error('Missing variantId'));
    }

    var properties = {
      _design_ref: data.designRef,
      _customizer_id: data.customizerConfig || customizerId
    };

    if (data.storageUrl) {
      properties._artwork_url = data.storageUrl;
    }

    if (data.previewUrl) {
      properties._preview_url = data.previewUrl;
    }

    var payload = {
      id: parseInt(variantId, 10),
      quantity: 1,
      properties: properties
    };

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Cart add failed: ' + response.status);
      return response.json();
    })
    .then(function(lineItem) {
      return fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count);

          closeEditorModal();

          document.dispatchEvent(new CustomEvent('hw-editor:cart-added', {
            detail: {
              designRef: data.designRef,
              variantId: variantId,
              storageUrl: data.storageUrl || null,
              previewUrl: data.previewUrl || null,
              itemCount: cart.item_count,
              lineItem: lineItem
            }
          }));

          window.location.href = '/cart';
        });
    })
    .catch(function(err) {
      showToast('Error adding to cart. Please try again.');
      console.error('[HW Customizer] Cart add error:', err);
    });
  }

  function closeEditorModal() {
    try {
      var overlay = document.querySelector('.hw-editor-overlay.hw-editor-open');
      if (overlay) {
        overlay.classList.remove('hw-editor-open');
        document.body.style.overflow = '';
      }
      if (window.HWEditor && window.HWEditor.close) {
        window.HWEditor.close();
      }
    } catch (e) {}
  }

  function loadEditor(callback) {
    if (editorLoaded) {
      callback();
      return;
    }
    if (editorLoading) {
      var check = setInterval(function() {
        if (editorLoaded) {
          clearInterval(check);
          callback();
        }
      }, 100);
      return;
    }

    editorLoading = true;
    var cacheBust = '?v=20260609a';

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = EDITOR_BASE + '/editor.css' + cacheBust;
    document.head.appendChild(link);

    var script = document.createElement('script');
    script.src = EDITOR_BASE + '/editor.js' + cacheBust;
    script.onload = function() {
      editorLoaded = true;
      editorLoading = false;
      callback();
    };
    script.onerror = function() {
      editorLoading = false;
      showToast('Failed to load editor. Please refresh and try again.');
    };
    document.head.appendChild(script);
  }

  function onEditorAddToCart(e) {
    var d = e.detail || {};
    addToCart({
      variantId: d.variantId || currentVariantId,
      previewUrl: d.previewUrl || null,
      designRef: d.designRef,
      storageUrl: d.storageUrl || null,
      customizerConfig: d.customizerConfig || customizerId
    });
  }

  var editorEventBound = false;

  function getDesignRefFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get('design_ref') || '';
  }

  function openEditor() {
    var activeCustomizerId = getCustomizerIdForVariant(currentVariantId) || customizerId;

    if (!editorEventBound) {
      document.addEventListener('hw-editor:add-to-cart', onEditorAddToCart);
      editorEventBound = true;
    }

    loadEditor(function() {
      if (!window.HWEditor) {
        showToast('Editor failed to initialize.');
        return;
      }

      // Destroy previous editor instance so a fresh one is created for the current variant
      if (currentEditorInstance && typeof currentEditorInstance.destroy === 'function') {
        currentEditorInstance.destroy();
        currentEditorInstance = null;
      }

      var editorConfig = {
        customizerId: activeCustomizerId,
        id: activeCustomizerId,
        layoutId: getLayoutIdForVariant(currentVariantId),
        overlayId: getOverlayIdForVariant(currentVariantId),
        variantId: currentVariantId,
        productTitle: getProductTitle(),
        productUrl: window.location.href,
        restoreDesignRef: getDesignRefFromUrl()
      };

      if (typeof window.HWEditor.init === 'function') {
        var instance = window.HWEditor.init(editorConfig);
        currentEditorInstance = instance;
        window.HWEditor.close = function() { instance.modal.close(); };
        instance.open();
      } else {
        showToast('Editor failed to initialize.');
      }
    });
  }

  function watchVariantChanges() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    if (idInput) {
      var observer = new MutationObserver(function() {
        currentVariantId = idInput.value;
        applyVariantState();
      });
      observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });

      idInput.addEventListener('change', function() {
        currentVariantId = idInput.value;
        applyVariantState();
      });
    }

    window.addEventListener('popstate', function() {
      var params = new URLSearchParams(window.location.search);
      var v = params.get('variant');
      if (v) currentVariantId = v;
      applyVariantState();
    });

    document.addEventListener('variant:changed', function(e) {
      if (e.detail && e.detail.variant) {
        currentVariantId = String(e.detail.variant.id);
      }
      applyVariantState();
    });

    document.addEventListener('change', function(e) {
      var target = e.target;
      if (target && target.dataset && target.dataset.customizerId) {
        customizerId = target.dataset.customizerId;
      }
    });
  }

  function watchCartPreviews() {
    if (!isCartPage()) return;
    customizeCartFromApi();

    var observer = new MutationObserver(function() {
      customizeCartFromApi();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function isCartPage() {
    return /\/cart\b/.test(window.location.pathname);
  }

  function customizeCartFromApi() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart || !cart.items) return;

        var cartItems = document.querySelectorAll(
          '.cart-item, .cart__item, [data-cart-item], .js-cart-item, tr[data-line-item], cart-items .line-item'
        );

        cart.items.forEach(function(lineItem, index) {
          var props = lineItem.properties || {};
          var previewUrl = props._preview_url || '';
          var designRef = props._design_ref || '';

          if (!previewUrl && !designRef) return;

          var domItem = cartItems[index];
          if (!domItem || domItem.getAttribute('data-hw-customized')) return;

          if (previewUrl && previewUrl.indexOf('http') === 0) {
            var img = domItem.querySelector('img');
            if (img) {
              img.src = previewUrl;
              img.srcset = '';
              img.style.objectFit = 'contain';
            }
          }

          if (designRef && !domItem.querySelector('.hw-cart-edit-btn')) {
            var productLink = domItem.querySelector('a[href*="/products/"]');
            var productUrl = productLink ? productLink.getAttribute('href').split('?')[0] : '';
            if (productUrl) {
              var editLink = document.createElement('a');
              editLink.href = productUrl + '?design_ref=' + encodeURIComponent(designRef);
              editLink.className = 'hw-cart-edit-btn';
              editLink.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg> Edit Design';
              var detailArea = domItem.querySelector('.cart-item__details, .cart__item-details, td:nth-child(2), .line-item__details');
              if (detailArea) {
                detailArea.appendChild(editLink);
              } else {
                domItem.appendChild(editLink);
              }
            }
          }

          domItem.setAttribute('data-hw-customized', 'true');

          // Hide internal properties from display
          var hiddenProps = domItem.querySelectorAll(
            '[data-property-name^="_design"], [data-property-name^="_preview"], [data-property-name^="_artwork"], [data-property-name^="_customizer"]'
          );
          hiddenProps.forEach(function(el) {
            var row = el.closest('li, tr, .product-option') || el.parentElement;
            if (row) row.style.display = 'none';
          });
        });
      })
      .catch(function(e) {
        console.error('[HW Customizer] Cart API error:', e);
      });
  }

  function init() {
    injectStyles();

    // Always run cart customization on cart pages
    watchCartPreviews();

    var config = getConfig();
    if (!config || !config.id) return;

    customizerId = config.id;
    currentVariantId = getSelectedVariantId();

    var atcButton = findAddToCartButton();
    if (!atcButton) return;

    var btn = createButton();
    btn.addEventListener('click', openEditor);
    hwButton = btn;
    nativeAtcButton = atcButton;

    try {
      var parent = atcButton.parentNode;
      parent.insertBefore(btn, atcButton);

      var paymentButton = parent.querySelector('.shopify-payment-button');
      if (paymentButton && paymentButton !== atcButton) {
        nativePaymentButton = paymentButton;
      }
    } catch (e) {
      console.error('[HW Customizer] Button injection failed:', e);
      return;
    }

    watchVariantChanges();

    // Decide, per current variant, whether to show the customizer button or
    // fall back to the native Add to Cart. Variants (or parent) without both a
    // customizer id and a layout id keep the standard buy button.
    applyVariantState();

    if (getDesignRefFromUrl() && variantHasCustomizer(currentVariantId)) {
      openEditor();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
